export const APP_STORE_URL = 'https://apps.apple.com/ph/app/talent-app-by-casting-com/id1634450341';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.casting.talent&hl=en';
